var map = {
	"./ad.svg": "9c20",
	"./al.svg": "6fe4",
	"./am.svg": "1835",
	"./at.svg": "c9b6",
	"./ba.svg": "b774",
	"./be.svg": "d2b6",
	"./bg.svg": "5d48",
	"./by.svg": "6e6b",
	"./ca.svg": "0a68",
	"./ch.svg": "b096",
	"./cn.svg": "2773",
	"./cy.svg": "1436",
	"./cz.svg": "eebd",
	"./de.svg": "96de",
	"./dk.svg": "fd12",
	"./ee.svg": "2ea5",
	"./es.svg": "020c",
	"./fi.svg": "92be",
	"./fr.svg": "cc0a",
	"./gb.svg": "39f8",
	"./gi.svg": "8973",
	"./gr.svg": "da48",
	"./hr.svg": "a95f",
	"./hu.svg": "9298",
	"./ie.svg": "0542",
	"./is.svg": "8d40",
	"./it.svg": "e6aa",
	"./jp.svg": "1390",
	"./li.svg": "7ec4",
	"./lt.svg": "33a6",
	"./lu.svg": "0b9f",
	"./lv.svg": "d4fe",
	"./ma.svg": "5a8a",
	"./mc.svg": "1d35",
	"./mk.svg": "ba49",
	"./mt.svg": "0b5d",
	"./nl.svg": "62d0",
	"./no.svg": "e049",
	"./pl.svg": "4e5a",
	"./pt.svg": "d3c7",
	"./ro.svg": "8727",
	"./ru.svg": "2c41",
	"./se.svg": "553b",
	"./si.svg": "5d2d",
	"./sk.svg": "4d01",
	"./sm.svg": "aa31e",
	"./ua.svg": "1f53",
	"./us.svg": "a525"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1931";